// Keep retired destinations out of dynamic navigation as well as static links.
// Database entries and cached app catalogues can outlive a feature's removal.
export function isRetiredFeatureLink(path: string): boolean {
  try {
    const pathname = new URL(path, window.location.origin).pathname
    const retired = /^\/(?:home-new\/)?it-management(?:\/|$)/i
    return retired.test(pathname) || retired.test(decodeURIComponent(pathname))
  } catch { return false }
}
